import { Inject, NgModule } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import browserHelper from '@utils/browser-helper';
import { IFBWindow } from '@app/models/window-namespace';

@NgModule()
export class CrowdinLoaderModule {
  private window: IFBWindow = window as any;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.init();
  }

  init() {
    if (browserHelper.preferredLanguage !== 'af' && browserHelper.preferredLanguage !== 'an') {
      return;
    }

    this.window._jipt = [];

    if (browserHelper.preferredLanguage === 'af') {
      this.window._jipt.push(['project', 'hummingbird']);
    } else if (browserHelper.preferredLanguage === 'an') {
      this.window._jipt.push(['project', 'hummingbird-en']);
    }

    const s = this.document.createElement('script');
    s.type = 'text/javascript';
    s.src = '//cdn.crowdin.com/jipt/jipt.js';
    const x = this.document.getElementsByTagName('script')[0];
    if (x.parentNode) {
      x.parentNode.insertBefore(s, x);
    }
  }
}
